import IncTextField, {
  IncTextFieldProps,
} from 'components/forms/fields/inc-text-field/inc-text-field.component';

const DisplayInformationTitleField = (props: IncTextFieldProps) => {
  return <IncTextField {...props} />;
};

export default DisplayInformationTitleField;
